
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKUItemBOMDialog extends Common.GridEditorDialog<SKUItemBOMRow> {
        protected getFormKey() { return SKUItemBOMForm.formKey; }
        //protected getIdProperty() { return SKUItemBOMRow.idProperty; }
        protected getLocalTextPrefix() { return SKUItemBOMRow.localTextPrefix; }
        //protected getNameProperty() { return SKUItemBOMRow.nameProperty; }
        //protected getService() { return SKUItemBOMService.baseUrl; }
        protected getDeletePermission() { return SKUItemBOMRow.deletePermission; }
        protected getInsertPermission() { return SKUItemBOMRow.insertPermission; }
        protected getUpdatePermission() { return SKUItemBOMRow.updatePermission; }

        protected form = new SKUItemBOMForm(this.idPrefix);

    }
}